import { jsx as _jsx } from "react/jsx-runtime";
import TableCell from "@mui/material/TableCell";
/**
 * @deprecated use material-react-table
 * @param props
 * @returns
 */
function DataTableCell(props) {
    const { column, row } = props;
    const RenderCell = column.renderCell;
    return (_jsx(TableCell, { className: "DataTableCell", sx: {
            textAlign: column.type === "number" ? "right" : undefined,
            whiteSpace: "break-spaces",
        }, children: RenderCell ? (_jsx(RenderCell, Object.assign({}, props))) : row[column.field] }, column.field));
}
export default DataTableCell;
//# sourceMappingURL=DataTableCell.js.map